import { SET_VIEWERS } from 'types/actions/viewers'

export const setViewers = count => ({
  type: SET_VIEWERS,
  count
})



// WEBPACK FOOTER //
// ./src/actions/viewers.js